import React, { useState } from 'react';
import { Modal } from './Modal';
const serif = {
  fontFamily: "'Fraunces', serif"
};
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <>
      <footer className="bg-[#2B2A26] text-[#FAF6F0]/70 px-6 py-12 border-t border-white/5" data-id="element-136">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-137">
          <p className="text-2xl text-[#FAF6F0]" style={serif} data-id="element-138">
            Cortisol & El Sueño Americano
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm" data-id="element-139">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-[#D99A5A] transition-colors underline-offset-4 hover:underline" data-id="element-140">
              Política de Privacidad
            </button>
            <button onClick={() => setOpenModal('terms')} className="hover:text-[#D99A5A] transition-colors underline-offset-4 hover:underline" data-id="element-141">
              Términos y Condiciones
            </button>
          </nav>
        </div>
        <div className="max-w-5xl mx-auto mt-8 pt-6 border-t border-white/5 text-xs text-[#FAF6F0]/50 text-center md:text-left" data-id="element-142">
          © {new Date().getFullYear()} Cortisol & El Sueño Americano. Todos los
          derechos reservados.
          <br className="md:hidden" data-id="element-143" />
          <span className="md:ml-2 block md:inline mt-2 md:mt-0" data-id="element-144">
            Este producto es de carácter informativo y no sustituye consejo
            médico profesional.
          </span>
        </div>
      </footer>

      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-145">
        <p className="text-sm text-[#2B2A26]/50 italic" data-id="element-146">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-147">
          1. Información que recopilamos
        </h3>
        <p data-id="element-148">
          Cuando adquieres el ebook <em data-id="element-149">Cortisol & El Sueño Americano</em>,
          recopilamos tu nombre, dirección de correo electrónico e información
          de pago necesaria para procesar tu compra y entregarte el material
          digital. No almacenamos los datos completos de tu tarjeta; estos son
          procesados de forma segura por nuestros proveedores de pago.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-150">
          2. Uso de tu información
        </h3>
        <p data-id="element-151">
          Utilizamos tu correo electrónico únicamente para enviarte el ebook, el
          Protocolo de 21 Días, materiales complementarios y, ocasionalmente,
          contenido educativo relacionado con la regulación hormonal. Puedes
          darte de baja en cualquier momento haciendo clic en el enlace al pie
          de cada correo.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-152">
          3. Compartir información con terceros
        </h3>
        <p data-id="element-153">
          No vendemos ni compartimos tu información personal con terceros, salvo
          cuando sea estrictamente necesario para procesar tu pago o cuando la
          ley lo requiera.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-154">
          4. Cookies
        </h3>
        <p data-id="element-155">
          Utilizamos cookies para mejorar tu experiencia en el sitio y analizar
          el tráfico. Puedes desactivar las cookies en la configuración de tu
          navegador.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-156">
          5. Tus derechos
        </h3>
        <p data-id="element-157">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, escríbenos
          a través del correo de soporte que aparece en tu recibo de compra.
        </p>
      </Modal>

      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-158">
        <p className="text-sm text-[#2B2A26]/50 italic" data-id="element-159">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-160">
          1. Descripción del producto
        </h3>
        <p data-id="element-161">
          Al realizar tu compra, recibirás acceso digital al ebook{' '}
          <em data-id="element-162">Cortisol & El Sueño Americano</em>, el Protocolo de Reset de 21
          Días y los materiales complementarios descritos en esta página. La
          entrega es inmediata y se realiza al correo electrónico que
          proporciones.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-163">
          2. Aviso médico
        </h3>
        <p data-id="element-164">
          El contenido de este producto es de carácter{' '}
          <strong data-id="element-165">educativo e informativo</strong>. No reemplaza el consejo,
          diagnóstico o tratamiento de un profesional de la salud. Antes de
          realizar cambios en tu alimentación, hábitos o suplementación,
          consulta con tu médico, especialmente si tienes condiciones
          preexistentes, estás embarazada o en período de lactancia.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-166">
          3. Política de reembolso
        </h3>
        <p data-id="element-167">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son <strong data-id="element-168">finales</strong>. No ofrecemos reembolsos
          una vez completada la compra. Si tienes algún problema con tu acceso,
          contáctanos y lo resolveremos lo antes posible.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-169">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-170">
          Todo el contenido del ebook y los materiales complementarios es
          propiedad de Cortisol & El Sueño Americano. Está prohibida su
          redistribución, reventa o reproducción total o parcial sin
          autorización por escrito.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-171">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-172">
          Los resultados pueden variar según la persona, su contexto y su nivel
          de adherencia al protocolo. No garantizamos resultados específicos. Al
          comprar, reconoces que asumes la responsabilidad de tu propia salud y
          bienestar.
        </p>
        <h3 className="text-lg font-semibold text-[#2B2A26] pt-2" data-id="element-173">
          6. Contacto
        </h3>
        <p data-id="element-174">
          Para cualquier consulta sobre estos términos, escríbenos al correo de
          soporte que aparece en tu recibo de compra.
        </p>
      </Modal>
    </>;
}